import React from "react";

import { useProjectResourcesRetrieval } from "@planzone/view-models";
import { Identifiable, ProjectResource } from "@planzone/dto";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { SelectList } from "@common/selectList";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function AddMember({
  project,
  projectResources: groupMembers,
  addResources,
  removeResources,
}: Props) {
  const { projectResources } = useProjectResourcesRetrieval(project);

  return (
    <SelectList listClassName={styles.list} multiple>
      {() => ({
        input: <AddAllocationIcon className={styles.icon} />,
        list: (
          <ResourceAllocationMenu
            allocatedResources={groupMembers.map(({ resource }) => resource)}
            select={(resources) => {
              addResources(
                resources
                  .map(({ uuid }) =>
                    projectResources.find(
                      ({ resource }) => resource.uuid === uuid,
                    ),
                  )
                  .filter(
                    (r) => !!r && !r.deactivated,
                  ) as Identifiable<ProjectResource>[],
              );
            }}
            unSelect={(resources) => {
              removeResources(
                resources
                  .map(({ uuid }) =>
                    projectResources.find(
                      ({ resource }) => resource.uuid === uuid,
                    ),
                  )
                  .filter((r) => !!r) as Identifiable<ProjectResource>[],
              );
            }}
            openedViews={["resources"]}
          />
        ),
      })}
    </SelectList>
  );
}

export { AddMember };
